module.exports = __webpack_public_path__ + "img/Group_sec3-1.9c0d04fb.png";